// @flow

import React from 'react';
import type { FieldProps } from '../../../../types';
import { ReduxFormCheckbox } from '../../checkbox';
import LabeledCheckbox from './labeledCheckbox';

type Props = {|
  ...FieldProps,
  label: string,
|};

export default ({ label, ...rest }: Props) => (
  <LabeledCheckbox label={label}>
    <ReduxFormCheckbox {...rest} label={label} />
  </LabeledCheckbox>
);
